import { useEffect, useState } from 'react';

const cache = new Map();

/** Natural width:height of an image URL (null until loaded). Cached per URL. */
export default function useImageAspect(url) {
  const [aspect, setAspect] = useState(() => (url && cache.get(url)) || null);
  useEffect(() => {
    if (!url) {
      setAspect(null);
      return undefined;
    }
    if (cache.has(url)) {
      setAspect(cache.get(url));
      return undefined;
    }
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (!img.naturalWidth || !img.naturalHeight) return;
      const ratio = img.naturalWidth / img.naturalHeight;
      cache.set(url, ratio);
      if (!cancelled) setAspect(ratio);
    };
    img.src = url;
    return () => {
      cancelled = true;
    };
  }, [url]);
  return aspect;
}
